import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiDocumentDto } from '../../../services/documents/documents.model';
import { FileWithCustomUploading } from './add-related-document.model';

@Injectable()
export class AddRelatedDocumentService {
  constructor(private httpClient: HttpClient) {}

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (): void => {
        if (typeof reader.result === 'string') {
          resolve(reader.result.split(',')[1]);
        }
      };
      reader.onerror = (err): void => {
        reject(err);
      };
    });
  }

  private convertCustomFileToApiDocument(
    file: FileWithCustomUploading,
    docUuid?: string,
    isPendingForSignature?: boolean,
  ): Promise<ApiDocumentDto> {
    return this.fileToBase64(file).then(
      (fileBase) =>
        new ApiDocumentDto(
          file.name,
          fileBase,
          docUuid,
          file.description,
          isPendingForSignature ? undefined : file.docType,
          isPendingForSignature ? undefined : 'dzzglczeka',
        ),
    );
  }

  postNewDocument(
    file: FileWithCustomUploading,
    docUuid: string,
    url: string,
  ): Promise<Observable<any>> {
    return this.convertCustomFileToApiDocument(file, docUuid).then(
      (apiDocModel) => {
        const req = new HttpRequest('POST', url, apiDocModel, {
          reportProgress: true,
        });

        return this.httpClient.request(req);
      },
    );
  }

  postNewDocuments(
    files: FileWithCustomUploading[],
    docUuid: string,
    url: string,
    isPendingForSignature?: boolean,
  ): Promise<Observable<any>> {
    return Promise.all(
      files.map((file) =>
        this.convertCustomFileToApiDocument(
          file,
          undefined,
          isPendingForSignature,
        ),
      ),
    ).then((apiDocModels) => {
      const req = new HttpRequest(
        'POST',
        url,
        { OwnerUuid: docUuid, Dokumenty: apiDocModels },
        {
          reportProgress: true,
        },
      );

      return this.httpClient.request(req);
    });
  }
}
